<div class="wrapper">
  <div
    class="input number-input view-mode"
    >
    <div class="label">
      <div class="label-name">{{ label }}</div>
      @if (uom) {
        <div class="uom">&nbsp;({{ uom }})</div>
      }
      @if (required) {
        <span>*&nbsp;</span>
      }
      :
    </div>
    <div class="value-wrapper bg-[#E9ECF4]">
      <div [innerHTML]="value"></div>
      @if (supportingValue) {
        <div class="supporting-value"> ({{ supportingValue }})</div>
      }
    </div>

    <div class="hint" [style.color]="hintColor">{{ hint }}</div>
  </div>
</div>
